const querystring = new URLSearchParams(window.location.search);
export function queryStringOrSessionStorage(key: string): string | undefined {
    if (querystring.has(key)) {
        const value = querystring.get(key)!;
        // @ts-expect-error Typescript doesn't yet include requestStorageAccess with arguments
        document.requestStorageAccess({ sessionStorage: true }).then(() => sessionStorage.setItem(key, value));
        return value;
    } else {
        const value = sessionStorage.getItem(key);
        return value ?? undefined;
    }
}
export function queryStringOrSessionStorageArray(key: string): string[] | undefined {
    if (querystring.has(key)) {
        const value = querystring.getAll(key)!;
        document
            // @ts-expect-error Typescript doesn't yet include requestStorageAccess with arguments
            .requestStorageAccess({ sessionStorage: true })
            .then(() => sessionStorage.setItem(key, JSON.stringify(value)));
        return value;
    } else {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : undefined;
    }
}
